
let sliders = () => {}

export { sliders }
